import React from 'react';
import { Link } from 'react-router-dom';
import {
  Bus, MapPin, Phone, Mail, Facebook, Instagram,
  Twitter, Youtube, Clock, CreditCard, Shield
} from 'lucide-react';
import './Footer.css';
import logo from '../../assets/logo_1.png';
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-column">
            <div className="footer-logo">
               <img src={logo} alt="Multipower Tour Logo" className="logos-image" />
            </div>
            <p className="footer-description">
              Transport modern și confortabil cu rute eficiente,
              bilete digitale și urmărire în timp real.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/MultipowerTour" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              {/* <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <Youtube size={20} />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-title">Navigare Rapidă</h3>
            <ul className="footer-links">
              <li><Link to="/rute">Rute & Curse</Link></li>
              <li><Link to="/bilete">Cumpără Bilete</Link></li>
              <li><Link to="/flota">Flotă Vehicule</Link></li>
              <li><Link to="/tarife">Tarife & Abonamente</Link></li>
              <li><Link to="/blog">Noutăți & Anunțuri</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h3 className="footer-title">Servicii</h3>
            <ul className="footer-links">
              <li>
                <Link to="/bilete">
                  <CreditCard size={16} />
                  <span>Bilete Online</span>
                </Link>
              </li>
              <li>
                <Link to="/suport">
                  <Phone size={16} />
                  <span>Suport Clienți</span>
                </Link>
              </li>
              <li>
                <Link to="/rute">
                  <MapPin size={16} />
                  <span>Planificare Traseu</span>
                </Link>
              </li>
              <li>
                <Link to="/live">
                  <Clock size={16} />
                  <span>Urmărire Live</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>Str. Zefirului, Nr.19<br />Dorohoi, Botosani, România</span>
              </li>
              <li>
                <Phone size={18} />
                <span>
                  <a href="tel:+40740824224">+40740824224</a>
                </span>
              </li>
              <li>
                <Mail size={18} />
                <span>
                  <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a>
                </span>
              </li>
              <li>
                <Clock size={18} />
                <span>Luni - Vineri: 08:00 - 20:00<br />Sâmbătă - Duminică: 09:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} Multipower Tour SRL. Toate drepturile rezervate.
            </p>
            <div className="footer-legal">
              <Link to="/termeni">Termeni și Condiții</Link>
              <Link to="/confidentialitate">Politica de Confidențialitate</Link>
              <Link to="/gdpr">GDPR</Link>
              <Link to="/cookies">Cookies</Link>
              <Link to="/fonduri-europene">Fonduri Europene</Link>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
